import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { IUserInforResponse } from 'Data/interfaces/Auth/IUserInfoResponse';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { useQueryUniqueObra } from 'Hooks/obras/useQueryUniqueObra';
import useOptionsSelect from 'Pages/Activities/Modals/ShowCreateActivity/useOptionsSelect';

interface IUseShowCreateActivityViewer {
  csId: number;
  userInfo?: IUserInforResponse;
}

const useShowCreateActivityViewer = ({ csId, userInfo }: IUseShowCreateActivityViewer) => {
  const navigate = useNavigate();
  const {data: obra} = useQueryUniqueObra({ csId, navigate });

  const [showActivityModal, setShowActivityModal] = useState(false);
  const [selectedActivityId, setSelectedActivityId] = useState<string | null>(null);

  const {
    listActivities,
    isLoading,
    isLoadingUpdate,
    isLoadingDelete,
    updateStatus,
    getOld,
    newActivityGuid,
    topicStatusOptions = [],
    topicTypesOptions = [],
    topicStagesOptions = [],
    topicPointsOptions = [],
    topicCommunicationTypesOptions = [],
  } = useSelector((state: IGlobalReducerState) => state.activities);

  const {
    newEditLoading,
  } = useSelector((state: IGlobalReducerState) => state.obra);

  const disciplines = (obra?.Disciplines || []) as any;

  const {
    visibilityOptions,
    priorityOptions,
    priorityNoBgOptions,
    statusOptions,
    typeOptions,
    stageOptions,
    pointsOptions,
    communicationOptions,
    userOptions,
    disciplineOptions,
  } = useOptionsSelect({
    topicStatusOptions: topicStatusOptions || [],
    topicStagesOptions: topicStagesOptions || [],
    topicPointsOptions: topicPointsOptions || [],
    topicCommunicationTypesOptions: topicCommunicationTypesOptions || [],
    topicTypesOptions: topicTypesOptions || [],
    constructionSiteDisciplinesOptions: disciplines || [],
    usersOptions: [],
  });

  const selectedActivity = selectedActivityId && listActivities?.activities
    ? listActivities.activities[selectedActivityId]
    : null;

  const handleOpenActivity = (activityId: string) => {
    setSelectedActivityId(activityId);
    setShowActivityModal(true);
  };

  const handleCloseActivity = () => {
    setShowActivityModal(false);
    setSelectedActivityId(null);
  };

  const handleOpenShowActivity = (activityId: string) => {
    handleOpenActivity(activityId);
  };

  return {
    showActivityModal,
    selectedActivity,
    isLoading,
    isLoadingUpdate,
    isLoadingDelete,
    topicStatus: topicStatusOptions || [],
    topicStages: topicStagesOptions || [],
    topicPoints: topicPointsOptions || [],
    topicCommunicationType: topicCommunicationTypesOptions || [],
    visibilityOptions,
    priorityOptions,
    priorityNoBgOptions,
    statusOptions,
    typeOptions,
    stageOptions,
    pointsOptions,
    communicationOptions,
    userOptions,
    disciplineOptions,
    disciplines,
    updateStatus,
    getOld,
    newActivityGuid,
    userInfo,
    editStage: false,
    allowOnlyStagesLinkedToDisciplinesInTopics: obra?.AllowOnlyStagesLinkedToDisciplinesInTopics || false,
    createStageLoading: newEditLoading || false,
    handleOpenActivity,
    handleCloseActivity,
    handleOpenShowActivity,
  };
};

export default useShowCreateActivityViewer;
